import React from "react";

import {
    FaMapMarkerAlt,
    FaPhoneAlt,
    FaEnvelope,
    FaFacebookF,
    FaTwitter,
    FaInstagram,
    FaLinkedinIn,
    FaCode,
    FaArrowRight,
    FaPaperPlane,
    FaChevronRight,
    FaClock,
    FaDatabase,
    FaGlobe,
    FaServer,
    FaLaptopCode,
    FaMobileAlt,
    FaLayerGroup,
    FaCheckCircle,
} from "react-icons/fa";

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="polu-footer">

            <style>{`

                .polu-footer {
                    position: relative;
                    width: 100%;
                    overflow: hidden;
                    background:
                        linear-gradient(
                            180deg,
                            #ffffff 0%,
                            #f8fafc 48%,
                            #f1f5f9 100%
                        );
                    color: #111827;
                    font-family: "Poppins", "Inter", sans-serif;
                    border-top: 1px solid #e5e7eb;
                }

                .polu-footer::before {
                    content: "";
                    position: absolute;
                    width: 380px;
                    height: 380px;
                    border-radius: 50%;
                    background: rgba(249, 115, 22, 0.07);
                    top: -180px;
                    left: -160px;
                    pointer-events: none;
                }

                .polu-footer::after {
                    content: "";
                    position: absolute;
                    width: 420px;
                    height: 420px;
                    border-radius: 50%;
                    background: rgba(14, 165, 233, 0.06);
                    bottom: -220px;
                    right: -180px;
                    pointer-events: none;
                }

                .polu-footer-accent {
                    position: relative;
                    width: 100%;
                    height: 5px;
                    display: flex;
                    overflow: hidden;
                }

                .polu-footer-accent span {
                    flex: 1;
                }

                .polu-footer-accent span:nth-child(1) {
                    background: #f97316;
                }

                .polu-footer-accent span:nth-child(2) {
                    background: #0ea5e9;
                }

                .polu-footer-accent span:nth-child(3) {
                    background: #111827;
                }

                .polu-footer-accent span:nth-child(4) {
                    background: #f59e0b;
                }

                .polu-footer-main {
                    position: relative;
                    z-index: 2;
                    max-width: 1450px;
                    margin: auto;
                    padding: 75px 5% 55px;
                    display: grid;
                    grid-template-columns:
                        minmax(280px, 1.25fr)
                        minmax(180px, 0.75fr)
                        minmax(180px, 0.75fr)
                        minmax(280px, 1fr);
                    gap: 55px;
                }

                .polu-footer-brand-section {
                    min-width: 0;
                }

                .polu-footer-brand {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    margin-bottom: 22px;
                }

                .polu-footer-brand-icon {
                    width: 58px;
                    height: 58px;
                    min-width: 58px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 17px;
                    color: #ffffff;
                    font-size: 25px;
                    background:
                        linear-gradient(
                            135deg,
                            #f97316,
                            #ea580c
                        );
                    box-shadow:
                        0 12px 30px rgba(249, 115, 22, 0.22);
                    position: relative;
                }

                .polu-footer-brand-icon::after {
                    content: "";
                    position: absolute;
                    inset: -5px;
                    border: 1px solid rgba(249, 115, 22, 0.18);
                    border-radius: 20px;
                }

                .polu-footer-brand-text h2 {
                    margin: 0;
                    font-size: 25px;
                    line-height: 1.1;
                    font-weight: 800;
                    letter-spacing: -0.7px;
                    color: #111827;
                }

                .polu-footer-brand-text h2 span {
                    color: #f97316;
                }

                .polu-footer-brand-text > span {
                    display: block;
                    margin-top: 7px;
                    color: #64748b;
                    font-size: 11px;
                    font-weight: 700;
                    letter-spacing: 1.6px;
                    text-transform: uppercase;
                }

                .polu-footer-description {
                    max-width: 470px;
                    margin: 0 0 25px;
                    color: #64748b;
                    font-size: 14px;
                    line-height: 1.9;
                }

                .polu-footer-services {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 9px;
                    margin-bottom: 28px;
                }

                .polu-footer-service {
                    display: inline-flex;
                    align-items: center;
                    gap: 7px;
                    padding: 8px 11px;
                    border-radius: 9px;
                    background: #ffffff;
                    border: 1px solid #e5e7eb;
                    color: #475569;
                    font-size: 11px;
                    font-weight: 600;
                    transition:
                        transform 0.25s ease,
                        border-color 0.25s ease,
                        color 0.25s ease,
                        box-shadow 0.25s ease;
                }

                .polu-footer-service svg {
                    color: #f97316;
                    font-size: 12px;
                }

                .polu-footer-service:hover {
                    transform: translateY(-3px);
                    border-color: rgba(249, 115, 22, 0.35);
                    color: #f97316;
                    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.07);
                }

                .polu-footer-social-area {
                    margin-top: 22px;
                }

                .polu-footer-social-area > span {
                    display: block;
                    margin-bottom: 12px;
                    color: #334155;
                    font-size: 12px;
                    font-weight: 700;
                    text-transform: uppercase;
                    letter-spacing: 1.1px;
                }

                .polu-footer-social-links {
                    display: flex;
                    gap: 10px;
                }

                .polu-footer-social-links a {
                    width: 39px;
                    height: 39px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 11px;
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                    color: #475569;
                    text-decoration: none;
                    transition:
                        transform 0.25s ease,
                        color 0.25s ease,
                        background 0.25s ease,
                        border-color 0.25s ease;
                }

                .polu-footer-social-links a:hover {
                    transform: translateY(-4px);
                    color: #ffffff;
                    background: #f97316;
                    border-color: #f97316;
                }

                .polu-footer-column {
                    min-width: 0;
                }

                .polu-footer-title {
                    display: flex;
                    align-items: center;
                    gap: 11px;
                    margin-bottom: 23px;
                }

                .polu-footer-title-icon {
                    width: 33px;
                    height: 33px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 9px;
                    color: #f97316;
                    background: #fff7ed;
                    border: 1px solid #fed7aa;
                    font-size: 13px;
                }

                .polu-footer-title h3 {
                    margin: 0;
                    font-size: 16px;
                    font-weight: 800;
                    color: #111827;
                }

                .polu-footer-column ul {
                    padding: 0;
                    margin: 0;
                    list-style: none;
                }

                .polu-footer-column li {
                    margin-bottom: 13px;
                }

                .polu-footer-column li a {
                    display: inline-flex;
                    align-items: center;
                    gap: 9px;
                    color: #64748b;
                    text-decoration: none;
                    font-size: 13px;
                    transition:
                        color 0.2s ease,
                        transform 0.2s ease;
                }

                .polu-footer-column li a svg {
                    color: #f97316;
                    font-size: 9px;
                    transition: transform 0.2s ease;
                }

                .polu-footer-column li a:hover {
                    color: #f97316;
                    transform: translateX(4px);
                }

                .polu-footer-column li a:hover svg {
                    transform: translateX(3px);
                }

                .polu-footer-contact-section {
                    min-width: 0;
                }

                .polu-footer-contact-grid {
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                }

                .polu-footer-contact-card {
                    display: flex;
                    align-items: flex-start;
                    gap: 12px;
                    padding: 13px;
                    border-radius: 13px;
                    background: rgba(255, 255, 255, 0.78);
                    border: 1px solid #e5e7eb;
                    transition:
                        transform 0.25s ease,
                        box-shadow 0.25s ease,
                        border-color 0.25s ease;
                }

                .polu-footer-contact-card:hover {
                    transform: translateY(-3px);
                    border-color: rgba(249, 115, 22, 0.28);
                    box-shadow: 0 10px 25px rgba(15, 23, 42, 0.06);
                }

                .polu-footer-contact-icon {
                    width: 35px;
                    height: 35px;
                    min-width: 35px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 9px;
                    background: #fff7ed;
                    color: #f97316;
                    font-size: 13px;
                }

                .polu-footer-contact-card span {
                    display: block;
                    margin-bottom: 3px;
                    color: #334155;
                    font-size: 11px;
                    font-weight: 700;
                    text-transform: uppercase;
                    letter-spacing: 0.7px;
                }

                .polu-footer-contact-card p {
                    margin: 0;
                    color: #64748b;
                    font-size: 12px;
                    line-height: 1.6;
                    word-break: break-word;
                }

                .polu-footer-connect {
                    position: relative;
                    z-index: 3;
                    max-width: 1350px;
                    margin: 0 auto;
                    padding: 25px 30px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 30px;
                    border-radius: 20px;
                    background:
                        linear-gradient(
                            135deg,
                            #ffffff,
                            #fff7ed
                        );
                    border: 1px solid #fed7aa;
                    box-shadow:
                        0 15px 45px rgba(15, 23, 42, 0.07);
                }

                .polu-footer-connect-content {
                    display: flex;
                    align-items: center;
                    gap: 14px;
                }

                .polu-footer-connect-icon {
                    width: 48px;
                    height: 48px;
                    min-width: 48px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 14px;
                    color: #ffffff;
                    background: #f97316;
                    box-shadow: 0 10px 25px rgba(249, 115, 22, 0.22);
                }

                .polu-footer-connect-content h4 {
                    margin: 0 0 4px;
                    color: #111827;
                    font-size: 15px;
                    font-weight: 800;
                }

                .polu-footer-connect-content p {
                    margin: 0;
                    color: #64748b;
                    font-size: 12px;
                }

                .polu-footer-newsletter {
                    display: flex;
                    width: min(100%, 480px);
                    height: 47px;
                    padding: 4px;
                    border-radius: 12px;
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                }

                .polu-footer-newsletter input {
                    flex: 1;
                    min-width: 0;
                    border: none;
                    outline: none;
                    padding: 0 13px;
                    background: transparent;
                    color: #111827;
                    font-size: 13px;
                    font-family: inherit;
                }

                .polu-footer-newsletter input::placeholder {
                    color: #94a3b8;
                }

                .polu-footer-newsletter button {
                    border: none;
                    outline: none;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    padding: 0 18px;
                    border-radius: 9px;
                    background: #111827;
                    color: #ffffff;
                    font-family: inherit;
                    font-size: 12px;
                    font-weight: 700;
                    cursor: pointer;
                    transition:
                        background 0.25s ease,
                        transform 0.25s ease;
                }

                .polu-footer-newsletter button:hover {
                    background: #f97316;
                    transform: translateY(-1px);
                }

                .polu-footer-motto {
                    position: relative;
                    z-index: 2;
                    max-width: 1000px;
                    margin: 50px auto 30px;
                    padding: 0 25px;
                    display: flex;
                    align-items: center;
                    gap: 20px;
                }

                .polu-footer-motto span {
                    flex: 1;
                    height: 1px;
                    background:
                        linear-gradient(
                            90deg,
                            transparent,
                            #cbd5e1
                        );
                }

                .polu-footer-motto span:last-child {
                    background:
                        linear-gradient(
                            90deg,
                            #cbd5e1,
                            transparent
                        );
                }

                .polu-footer-motto p {
                    margin: 0;
                    text-align: center;
                    color: #64748b;
                    font-size: 12px;
                    font-weight: 600;
                    letter-spacing: 0.8px;
                    white-space: nowrap;
                }

                .polu-footer-bottom {
                    position: relative;
                    z-index: 2;
                    background: #111827;
                    color: #ffffff;
                }

                .polu-footer-bottom-inner {
                    max-width: 1450px;
                    margin: auto;
                    padding: 23px 5%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 20px;
                }

                .polu-footer-bottom p {
                    margin: 0;
                    color: #94a3b8;
                    font-size: 11px;
                    line-height: 1.6;
                }

                .polu-footer-bottom p strong {
                    color: #f97316;
                }

                .polu-footer-bottom-links {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    flex-wrap: wrap;
                }

                .polu-footer-bottom-links a {
                    color: #cbd5e1;
                    text-decoration: none;
                    font-size: 11px;
                    transition: color 0.2s ease;
                }

                .polu-footer-bottom-links a:hover {
                    color: #f97316;
                }

                .polu-footer-bottom-links span {
                    color: #475569;
                    font-size: 10px;
                }

                @media (max-width: 1200px) {

                    .polu-footer-main {
                        grid-template-columns:
                            1.2fr
                            0.8fr
                            0.8fr;
                    }

                    .polu-footer-contact-section {
                        grid-column: 1 / -1;
                    }

                    .polu-footer-contact-grid {
                        display: grid;
                        grid-template-columns: repeat(2, 1fr);
                    }

                }

                @media (max-width: 900px) {

                    .polu-footer-main {
                        padding: 60px 5% 45px;
                        grid-template-columns:
                            1fr 1fr;
                        gap: 45px 35px;
                    }

                    .polu-footer-brand-section {
                        grid-column: 1 / -1;
                    }

                    .polu-footer-connect {
                        margin-left: 5%;
                        margin-right: 5%;
                    }

                }

                @media (max-width: 650px) {

                    .polu-footer-main {
                        grid-template-columns: 1fr;
                        padding: 50px 6% 40px;
                        gap: 35px;
                    }

                    .polu-footer-brand-section,
                    .polu-footer-contact-section {
                        grid-column: auto;
                    }

                    .polu-footer-brand-text h2 {
                        font-size: 21px;
                    }

                    .polu-footer-description {
                        font-size: 13px;
                    }

                    .polu-footer-contact-grid {
                        grid-template-columns: 1fr;
                    }

                    .polu-footer-connect {
                        margin-left: 5%;
                        margin-right: 5%;
                        padding: 22px;
                        flex-direction: column;
                        align-items: stretch;
                    }

                    .polu-footer-newsletter {
                        width: 100%;
                    }

                    .polu-footer-motto {
                        margin-top: 40px;
                    }

                    .polu-footer-motto span {
                        display: none;
                    }

                    .polu-footer-motto p {
                        width: 100%;
                        white-space: normal;
                        line-height: 1.7;
                    }

                    .polu-footer-bottom-inner {
                        padding: 22px 6%;
                        flex-direction: column;
                        align-items: flex-start;
                    }

                    .polu-footer-bottom-links {
                        gap: 8px;
                    }

                }

                @media (max-width: 420px) {

                    .polu-footer-brand {
                        align-items: flex-start;
                    }

                    .polu-footer-brand-icon {
                        width: 50px;
                        height: 50px;
                        min-width: 50px;
                        font-size: 21px;
                    }

                    .polu-footer-brand-text h2 {
                        font-size: 19px;
                    }

                    .polu-footer-brand-text > span {
                        font-size: 9px;
                        letter-spacing: 1px;
                    }

                    .polu-footer-newsletter {
                        height: auto;
                        flex-direction: column;
                        padding: 7px;
                        gap: 7px;
                    }

                    .polu-footer-newsletter input {
                        height: 42px;
                    }

                    .polu-footer-newsletter button {
                        height: 42px;
                    }

                }

                @media (prefers-reduced-motion: reduce) {

                    .polu-footer *,
                    .polu-footer *::before,
                    .polu-footer *::after {
                        transition: none !important;
                        animation: none !important;
                    }

                }

            `}</style>

            <div className="polu-footer-accent">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>

            <div className="polu-footer-main">

                <div className="polu-footer-brand-section">

                    <div className="polu-footer-brand">

                        <div className="polu-footer-brand-icon">
                            <FaCode />
                        </div>

                        <div className="polu-footer-brand-text">

                            <h2>
                                <span>POLU</span> TECH
                            </h2>

                            <span>
                                Integrated Technology & Digital Solutions
                            </span>

                        </div>

                    </div>

                    <p className="polu-footer-description">
                        We design and build modern digital solutions that
                        help organizations operate smarter, connect with
                        their users, and grow through technology.
                    </p>

                    <div className="polu-footer-services">

                        <div className="polu-footer-service">
                            <FaLaptopCode />
                            Web Development
                        </div>

                        <div className="polu-footer-service">
                            <FaDatabase />
                            Database Systems
                        </div>

                        <div className="polu-footer-service">
                            <FaServer />
                            Software Solutions
                        </div>

                        <div className="polu-footer-service">
                            <FaGlobe />
                            Digital Platforms
                        </div>

                        <div className="polu-footer-service">
                            <FaMobileAlt />
                            Mobile Solutions
                        </div>

                        <div className="polu-footer-service">
                            <FaLayerGroup />
                            IT Consulting
                        </div>

                    </div>

                    <div className="polu-footer-social-area">

                        <span>
                            Connect With POLU TECH
                        </span>

                        <div className="polu-footer-social-links">

                            <a
                                href="#"
                                aria-label="Facebook"
                            >
                                <FaFacebookF />
                            </a>

                            <a
                                href="#"
                                aria-label="Twitter"
                            >
                                <FaTwitter />
                            </a>

                            <a
                                href="#"
                                aria-label="Instagram"
                            >
                                <FaInstagram />
                            </a>

                            <a
                                href="#"
                                aria-label="LinkedIn"
                            >
                                <FaLinkedinIn />
                            </a>

                        </div>

                    </div>

                </div>

                <div className="polu-footer-column">

                    <div className="polu-footer-title">

                        <span className="polu-footer-title-icon">
                            <FaArrowRight />
                        </span>

                        <h3>
                            Company
                        </h3>

                    </div>

                    <ul>

                        <li>
                            <a href="#home">
                                <FaChevronRight />
                                <span>Home</span>
                            </a>
                        </li>

                        <li>
                            <a href="#about">
                                <FaChevronRight />
                                <span>About POLU TECH</span>
                            </a>
                        </li>

                        <li>
                            <a href="#services">
                                <FaChevronRight />
                                <span>Our Services</span>
                            </a>
                        </li>

                        <li>
                            <a href="#projects">
                                <FaChevronRight />
                                <span>Our Projects</span>
                            </a>
                        </li>

                        <li>
                            <a href="#clients">
                                <FaChevronRight />
                                <span>Our Clients</span>
                            </a>
                        </li>

                    </ul>

                </div>

                <div className="polu-footer-column">

                    <div className="polu-footer-title">

                        <span className="polu-footer-title-icon">
                            <FaCode />
                        </span>

                        <h3>
                            Technology
                        </h3>

                    </div>

                    <ul>

                        <li>
                            <a href="#web-development">
                                <FaChevronRight />
                                <span>Web Development</span>
                            </a>
                        </li>

                        <li>
                            <a href="#software">
                                <FaChevronRight />
                                <span>Software Development</span>
                            </a>
                        </li>

                        <li>
                            <a href="#database">
                                <FaChevronRight />
                                <span>Database Solutions</span>
                            </a>
                        </li>

                        <li>
                            <a href="#school-management">
                                <FaChevronRight />
                                <span>School Management Systems</span>
                            </a>
                        </li>

                        <li>
                            <a href="#api">
                                <FaChevronRight />
                                <span>API & Backend Systems</span>
                            </a>
                        </li>

                        <li>
                            <a href="#consulting">
                                <FaChevronRight />
                                <span>IT Consulting</span>
                            </a>
                        </li>

                    </ul>

                </div>

                <div className="polu-footer-contact-section">

                    <div className="polu-footer-title">

                        <span className="polu-footer-title-icon">
                            <FaMapMarkerAlt />
                        </span>

                        <h3>
                            Contact POLU TECH
                        </h3>

                    </div>

                    <div className="polu-footer-contact-grid">

                        <div className="polu-footer-contact-card">

                            <div className="polu-footer-contact-icon">
                                <FaMapMarkerAlt />
                            </div>

                            <div>

                                <span>
                                    Location
                                </span>

                                <p>
                                    Monrovia, Liberia
                                </p>

                            </div>

                        </div>

                        <div className="polu-footer-contact-card">

                            <div className="polu-footer-contact-icon">
                                <FaPhoneAlt />
                            </div>

                            <div>

                                <span>
                                    Phone
                                </span>

                                <p>
                                    +231 773 275 388
                                </p>

                            </div>

                        </div>

                        <div className="polu-footer-contact-card">

                            <div className="polu-footer-contact-icon">
                                <FaEnvelope />
                            </div>

                            <div>

                                <span>
                                    Email
                                </span>

                                <p>
                                    polutechonology@gmail.com
                                </p>

                            </div>

                        </div>

                        <div className="polu-footer-contact-card">

                            <div className="polu-footer-contact-icon">
                                <FaClock />
                            </div>

                            <div>

                                <span>
                                    Availability
                                </span>

                                <p>
                                    Mon - Fri: 8:00 AM - 5:00 PM
                                </p>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

            <div className="polu-footer-connect">

                <div className="polu-footer-connect-content">

                    <div className="polu-footer-connect-icon">
                        <FaEnvelope />
                    </div>

                    <div>

                        <h4>
                            Stay Connected With POLU TECH
                        </h4>

                        <p>
                            Get technology updates, product news,
                            and new digital solutions.
                        </p>

                    </div>

                </div>

                <div className="polu-footer-newsletter">

                    <input
                        type="email"
                        placeholder="Enter your email address"
                        aria-label="Email address"
                    />

                    <button
                        type="button"
                        aria-label="Subscribe to newsletter"
                    >
                        Subscribe
                        <FaPaperPlane />
                    </button>

                </div>

            </div>

            <div className="polu-footer-motto">

                <span></span>

                <p>
                    Code. Create. Connect. Transform Through Technology.
                </p>

                <span></span>

            </div>

            <div className="polu-footer-bottom">

                <div className="polu-footer-bottom-inner">

                    <p>
                        © {currentYear}{" "}
                        <strong>POLU TECH</strong>.
                        All Rights Reserved.
                    </p>

                    <div className="polu-footer-bottom-links">

                        <a href="#privacy">
                            Privacy Policy
                        </a>

                        <span>|</span>

                        <a href="#terms">
                            Terms & Conditions
                        </a>

                        <span>|</span>

                        <a href="#support">
                            Technical Support
                        </a>

                    </div>

                </div>

            </div>

        </footer>
    );
}